import React, { cloneElement, useEffect, useRef, useState } from 'react';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

interface Props {
  children: any;
  defaultExpanded?: boolean;
}

const Collapse: (React.FC<Props> & { Caret: any; Chevron: any; Trigger: any; }) = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);
  const [isExpanded, setIsExpanded] = useState(!!props.defaultExpanded);

  const determineContentHeight = useRef();

  useEffect(() => {
    const determineContentHeight = () => {
      if (ref.current) {
        setContentHeight(ref.current.clientHeight);
      }
    };

    determineContentHeight();

    window.addEventListener('resize', determineContentHeight);

    return () => {
      window.removeEventListener('resize', determineContentHeight);
    }
  }, [props.children]);

  const triggerChild = React.Children.toArray(props.children).find((child) => (
    (child as React.ReactElement<any>).type === Collapse.Trigger
  )) as React.ReactElement<any>;

  return (
    <div className="d-flex flex-column">
      {
        cloneElement(
          triggerChild,
          {
            ...triggerChild.props,
            isExpanded,
            onClick: () => setIsExpanded(!isExpanded)
          }
        )
      }

      <div
        style={{
          height: isExpanded ? contentHeight : 0,
          overflow: 'hidden',
          transition: 'height 200ms'
        }}
      >
        <div ref={ref}>
          {
            React.Children.toArray(props.children).filter((child) => (
              (child as React.ReactElement<any>).type !== Collapse.Trigger
            ))
          }
        </div>
      </div>
    </div>
  );
};

Collapse.Caret = ({ isExpanded }) => {
  return (
    <div
      style={{
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        borderTop: '5px solid #B2B2B2',
        height: 0,
        width: 0
      }}
    />
  );
};

Collapse.Chevron = ({ isExpanded }) => {
  return (
    <FontAwesomeIcon icon={isExpanded ? 'chevron-up' : 'chevron-down'} />
  );
};

Collapse.Trigger = (props) => {
  return (
    <div onClick={props.onClick} style={{ cursor: 'pointer', ...(props.style || {}) }}>
      {
        (typeof props.children === 'function') ? (
          (props.children as any)({ isExpanded: props.isExpanded })
        ) : props.children
      }
    </div>
  );
};

export default Collapse;
